export default __webpack_public_path__ + "static/media/frontface.2fedcf54.frag";